import React from "react";
import Person from "../Person";
import { ROLE_LABELS } from "./constants";

export default function WorkspaceHeader({ ws }) {
  return (
    <div className="card border-0 mb-4">
      <div className="card-body text-center p-4">
        <div
          className="tyn-media tyn-size-xl tyn-circle mx-auto mb-3"
          style={{
            width: 72,
            height: 72,
            overflow: "hidden",
          }}
        >
          {ws.imageUrl ? (
            <img
              src={ws.imageUrl}
              alt={ws.nom}
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          ) : (
            <Person
              person={{
                image: null,
                nom: ws.nom,
                prenom: "",
                userId: ws._id,
                colors: ws.color,
              }}
            />
          )}
        </div>
        <h4 className="mb-1">{ws.nom}</h4>
        {ws.description && (
          <p className="text-muted mb-1">{ws.description}</p>
        )}
        <span className="badge bg-light text-muted text-capitalize">
          {ROLE_LABELS[ws.role] || ws.role}
        </span>
      </div>
    </div>
  );
}
